module.exports = __webpack_public_path__ + "img/add-image-icon.2496b893.svg";